
import { QueryClient } from '@tanstack/react-query';


export const defaultQueryOptions = {
  staleTime: 0, // 30 minutes
  gcTime:0, // 60 minutes
  retry: (failureCount: number, error: Error) => {
    if (error.message.includes('4')) {
      return false;
    }
    return failureCount < 3;
  },
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
  refetchOnMount: false,
};

export const defaultMutationOptions = {
  retry: (failureCount: number, error: Error) => {
    if (error.message.includes('4')) {
      return false;
    }
    return failureCount < 2;
  },
};

export const createQueryClient = () => {
  return new QueryClient({
    defaultOptions: {
      queries: defaultQueryOptions,
      mutations: defaultMutationOptions,
    },
  });
};

export const handleQueryError = (error: unknown) => {
  if (error instanceof Error) {
    console.error('Query error:', error.message);
    return error.message;
  }
  console.error('Unknown query error:', error);
  return 'An unknown error occurred';
};

export const handleMutationError = (error: unknown) => {
  if (error instanceof Error) {
    console.error('Mutation error:', error.message);
    return error.message;
  }
  console.error('Unknown mutation error:', error);
  return 'An unknown error occurred';
};

export const isLoadingState = (isLoading: boolean, isFetching: boolean) => {
  return isLoading || isFetching;
};

export const isErrorState = (isError: boolean, error: unknown) => {
  return isError && error !== null;
}; 